import gql from "graphql-tag";
import * as Yup from "yup";
export const systemSettingForm = {
  title: "Campaign Global Setting",
  fields: [
    {
      name: "id",
      value: 1
    },
    {
      label: "Max Visits Per Day",
      type: "input",
      placeholder: "eg 100",
      name: "maxvisitperday",
      isRequired: true,
      value: ""
    },
    {
      label: "Max Follows Per Day",
      type: "input",
      placeholder: "eg 100",
      name: "maxfollowperday",
      isRequired: true,
      value: ""
    },
    {
      label: "Max Invites Per Day",
      type: "input",
      placeholder: "eg 100",
      name: "maxconnectionperday",
      isRequired: true,
      value: ""
    },
    {
      label: "Max Messages Per Day",
      type: "input",
      placeholder: "eg 100",
      name: "maxmessageperday",
      isRequired: true,
      value: ""
    },
    {
      label: "Max Open Messages Per Day",
      type: "input",
      placeholder: "eg 100",
      name: "maxopenmessageperday",
      isRequired: true,
      value: ""
    }
  ]
};
export const systemSettingValidation = Yup.object().shape({
  maxvisitperday: Yup.string()
    .required("Required")
    .matches(/^[0-9]*$/, {
      message: "Incorrect Format",
      excludeEmptyString: true
    })
    .max(9, "Max Visit Per Day should be less than 10 digits"),
  maxfollowperday: Yup.string()
    .required("Required")
    .matches(/^[0-9]*$/, {
      message: "Incorrect Format",
      excludeEmptyString: true
    })
    .max(9, "Max Follows Per Day should be less than 10 digits"),
  maxconnectionperday: Yup.string()
    .required("Required")
    .matches(/^[0-9]*$/, {
      message: "Incorrect Format",
      excludeEmptyString: true
    })
    .max(9, "Max Connection Per Day should be less than 10 digits"),
  maxmessageperday: Yup.string()
    .required("Required")
    .matches(/^[0-9]*$/, {
      message: "Incorrect Format",
      excludeEmptyString: true
    })
    .max(9, "Max Messages Per Day should be less than 10 digits")
        .max(9, "Max Connection Per Day should be less than 10 digits"),
  maxopenmessageperday: Yup.string()
    .required("Required")
    .matches(/^[0-9]*$/, {
      message: "Incorrect Format",
      excludeEmptyString: true
    })
    .max(9, "Max Messages Per Day should be less than 10 digits")
});

export const systemSetting = gql`
  mutation SystemsettingsUpsertWithWhere($id: JSON, $data: JSON) {
    SystemsettingsUpsertWithWhere(where: $id, data: $data) {
      id
    }
  }
`;

export const getData = gql`
  query {
    allSystemsettings(where: { id: 1 }) {
      Systemsettings {
        id
        maxvisitperday
        maxfollowperday
        maxconnectionperday
        maxmessageperday
        maxopenmessageperday
      }
    }
  }
`;
